import axios from "axios";
import config from "./config";
import qs from "qs";
axios.interceptors.request.use((config) => {
    config.paramsSerializer = (params) => {
        // Qs is already included in the Axios package
        return qs.stringify(params, {
            arrayFormat: "brackets",
            encode: false,
        });
    };
    return config;
});
function getToken() {
    if (config.token != "") {
        return config.token;
    }
    else {
        return window.localStorage.getItem("openkit");
    }
}
let index = {
    async create(entity, data) {
        const url = config.app_url == undefined ? "" : config.app_url + "data/" + entity;
        let reply = await axios.post(url, data, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async createR(entity, data) {
        const url = config.app_url == undefined ? "" : config.app_url + "data/" + entity;
        let reply = await axios.post(url, data, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply;
    },
    async update(entity, id, data) {
        let reply = await axios.put(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/" + id, data, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async updateR(entity, id, data) {
        let reply = await axios.put(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/" + id, data, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply;
    },
    async find(entity, query, pagination) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/find", { query, pagination }, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async findDistinct(entity, query, pagination) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/find-distinct", { query, pagination }, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async findR(entity, query, pagination) {
        try {
            let reply = await axios.post(config.app_url == undefined
                ? ""
                : config.app_url + "data/" + entity + "/find", { query, pagination }, {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
            });
            return reply;
        }
        catch (error) {
            return error;
        }
    },
    async count(entity, query, pagination) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/count", { query, pagination }, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async findOne(entity, query, pagination) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/find", { query, pagination }, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        if (reply.data.length > 0) {
            return reply.data[0];
        }
        else {
            return null;
        }
    },
    async sum(entity, field, query) {
        let reply = await axios.post(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/sum", { field, query }, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async get(entity, id, fields) {
        let url;
        if (config.app_url == undefined) {
            url = "";
        }
        else {
            url = config.app_url + "data/" + entity + "/" + id;
            if (fields && fields.length > 0) {
                let fieldsString = fields.join(",");
                url = url.concat("?fields=" + fieldsString);
            }
        }
        let reply = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
    async getR(entity, id, fields) {
        let url;
        if (config.app_url == undefined) {
            url = "";
        }
        else {
            url = config.app_url + "data/" + entity + "/" + id;
            if (fields && fields.length > 0) {
                let fieldsString = fields.join(",");
                url = url.concat("?fields=" + fieldsString);
            }
        }
        let reply = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply;
    },
    async delete(entity, id) {
        let reply = await axios.delete(config.app_url == undefined
            ? ""
            : config.app_url + "data/" + entity + "/" + id, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        });
        return reply.data;
    },
};
export default index;
